/**
 * @generated SignedSource<<4b8e16d76d683677f521625ac3c88a6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateNovaAgentAudienceInput = {
  id: string;
  add?: NovaAgentAudienceTargetsInput | null;
  remove?: NovaAgentAudienceTargetsInput | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type NovaAgentAudienceTargetsInput = {
  companyIds?: ReadonlyArray<string> | null;
  persons?: ReadonlyArray<NovaAgentAudiencePersonInput> | null;
};
export type NovaAgentAudiencePersonInput = {
  personId: string;
  companyId: string;
};
export type UpdateNovaAgentAudienceMutation$variables = {
  input: UpdateNovaAgentAudienceInput;
};
export type UpdateNovaAgentAudienceMutation$data = {
  readonly updateNovaAgentAudience: {
    readonly agent: {
      readonly id: string;
      readonly deployment: {
        readonly isLiveToAnyone: boolean;
        readonly companyCount: number;
        readonly userCount: number;
        readonly companies: ReadonlyArray<{
          readonly companyId: string;
        }>;
        readonly persons: ReadonlyArray<{
          readonly personId: string;
          readonly companyId: string;
        }>;
      } | null;
    } | null;
  } | null;
};
export type UpdateNovaAgentAudienceMutation = {
  variables: UpdateNovaAgentAudienceMutation$variables;
  response: UpdateNovaAgentAudienceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLiveToAnyone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateNovaAgentAudienceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateNovaAgentAudiencePayload",
        "kind": "LinkedField",
        "name": "updateNovaAgentAudience",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgent",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentDeployment",
                "kind": "LinkedField",
                "name": "deployment",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaAgentAudienceCompany",
                    "kind": "LinkedField",
                    "name": "companies",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaAgentAudiencePerson",
                    "kind": "LinkedField",
                    "name": "persons",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateNovaAgentAudienceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateNovaAgentAudiencePayload",
        "kind": "LinkedField",
        "name": "updateNovaAgentAudience",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgent",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NovaAgentDeployment",
                "kind": "LinkedField",
                "name": "deployment",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaAgentAudienceCompany",
                    "kind": "LinkedField",
                    "name": "companies",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NovaAgentAudiencePerson",
                    "kind": "LinkedField",
                    "name": "persons",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v6/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "552eb4e78870387d33f963195fbc00a7",
    "id": null,
    "metadata": {},
    "name": "UpdateNovaAgentAudienceMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateNovaAgentAudienceMutation(\n  $input: UpdateNovaAgentAudienceInput!\n) {\n  updateNovaAgentAudience(input: $input) {\n    agent {\n      id\n      deployment {\n        isLiveToAnyone\n        companyCount\n        userCount\n        companies {\n          companyId\n          id\n        }\n        persons {\n          personId\n          companyId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "43ac6dab9f82715540c16de3380d3edd";

export default node;
